class TokenService {

  getLocalRefreshToken() {
    const item = localStorage.getItem("user") || "";
    if (item) {
      const user = JSON.parse(item);
      return user?.refreshToken;
    }
    return null
  }

  getLocalAccessToken() {
    const item = localStorage.getItem("user") || "";
    if (item) {
      const user = JSON.parse(item);
      return user?.accessToken;
    }

    return null;
  }

  updateLocalAccessToken(token: string) {
    const item = localStorage.getItem("user") || ""
    if (item) {
      const user = JSON.parse(item)
      user.accessToken = token
      localStorage.setItem("user", JSON.stringify(user))
    }
  }

  getUser() {
    const item = localStorage.getItem("user") || "";
    if (item) {
      return JSON.parse(item);
    }
    return null
  }

  setUser(user: any) {
    localStorage.setItem("user", JSON.stringify(user));
  }

  removeUser() {
    localStorage.removeItem("user");
  }


}

export default new TokenService()